import { IUserProfile } from '../models/user-profile-model';
import UserProfileMapper from '../mappings/user-profile-mapper';
import { Config } from '../models/config-viewmodel';
import { Address, Ice, PhoneNumber } from '../models/user-profile-viewmodel';

class UserProfileService {
    private userProfileMapper = new UserProfileMapper();

    constructor() {}

    public getUserProfile = (config: Config, HttpService: any) => {
        return this.getUserData(this.getUserProfileQuery(), config, HttpService);
    }

    public updateUserProfilePhoneNumbers = (data: PhoneNumber[], HttpService: any) => {
        return this.postUserData(this.updateUserProfilePhoneNumbersQuery(), data.map(item => this.userProfileMapper.mapPhoneNumberReverse(item)), HttpService);
    }

    public updateUserProfileIce = (data: Ice, HttpService: any) => {
        return this.postUserData(this.updateUserProfileIceQuery(), this.userProfileMapper.mapIceReverse(data), HttpService);
    }

    public updateUserProfileAddress = (config: Config, data: Address, HttpService: any) => {
        return this.postUserData(this.updateUserProfileAddressQuery(config), this.userProfileMapper.mapAddressReverse(data), HttpService);
    }

    private getUserData = (url: string, config: Config, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(url).then((result: IUserProfile) => {
                resolve(this.userProfileMapper.mapUserProfile(result, config.language));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private postUserData = (url: string, data: any, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.post(url, data).then((result: any) => {
                resolve(result);
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getUserProfileQuery = (): string => {
        return `/api/userdata/userdata`;
    }

    private updateUserProfileIceQuery = (): string => {
        return `/api/userdata/userdata/ice`;
    }

    private updateUserProfilePhoneNumbersQuery = (): string => {
        return `/api/userdata/userdata/phonenumbers`;
    }

    private updateUserProfileAddressQuery = (config: Config): string => {
        return `/api/userdata/userdata/address?language=${config.language}`;
    }
}

export default new UserProfileService();